export default "__VITE_PUBLIC_ASSET__88ad3b3c__"